/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import SoftBadge from "components/SoftBadge";

function Author({ name, username, email }) {
  return (
    <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
      <SoftBox mr={2}>
        <SoftAvatar
          src={`https://ui-avatars.com/api/?name=${name}`}
          alt={name}
          size="sm"
          variant="rounded"
        />
      </SoftBox>
      <SoftBox display="flex" flexDirection="column">
        <SoftTypography variant="button" fontWeight="medium">
          {name} ({username})
        </SoftTypography>
        <SoftTypography variant="caption" color="secondary">
          {email}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

function Function({ job, org }) {
  return (
    <SoftBox display="flex" flexDirection="column">
      <SoftTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </SoftTypography>
      <SoftTypography variant="caption" color="secondary">
        {org}
      </SoftTypography>
    </SoftBox>
  );
}

const apiUrl = "https://api.getverceipt.com/api/v1";

function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export default function useAuthorsTableData() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = [
    { name: "id", align: "center" },
    { name: "store", align: "left" },
    { name: "model", align: "left" },
    { name: "type", align: "left" },
    { name: "status", align: "center" },
    { name: "created", align: "center" },
    { name: "action", align: "center" }
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/business/devices/list`, {
          method: 'POST',
          withCredentials: true,
          credentials: 'include', // make sure cookies/session are sent
          headers: {
            'Content-Type': 'application/json',
          },
        });        
        if (!response.ok) throw new Error("Network response was not ok");

        const data = await response.json();
        console.log(data)

        const formattedRows = data.map((user) => ({
          id: <SoftTypography variant="caption" color="secondary" fontWeight="medium">{user.id}</SoftTypography>,
          store: <SoftTypography variant="caption" color="secondary" fontWeight="medium">{user.store_id}</SoftTypography>,
          model: <SoftTypography variant="caption" color="secondary" fontWeight="medium">{user.model}</SoftTypography>,
          type: <SoftTypography variant="caption" color="secondary" fontWeight="medium">{user.type}</SoftTypography>,
          status: (
            <SoftBadge
              variant="gradient"
              badgeContent={user.status}
              color={
                user.status === "Active"
                  ? "success"
                  : user.status === "Maintenance"
                  ? "warning"
                  : "error"
              }
              size="xs"
              container
            />
          ),
          created: (
            <SoftTypography variant="caption" color="secondary" fontWeight="medium">
              {formatDate(user.created_at)}
            </SoftTypography>
          ),
          action: (
            <SoftTypography
              component="a"
              href="#"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              Edit
            </SoftTypography>
          ),
        }));

        setRows(formattedRows);
      } catch (error) {
        console.error("Failed to fetch users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { columns, rows, loading };
}
